module.exports = __webpack_public_path__ + "img/patrol-off.1999f0b2.svg";